namespace $ {

	export class $shm_date extends $mol_object2 {

		static text( date: string ) {
			const iso = String( date ?? '' ).match( /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/ )
			if( iso ) return `${ iso[3] }.${ iso[2] }.${ iso[1] }${ iso[4] ? ` ${ iso[4] }:${ iso[5] }` : '' }`
			const ru = String( date ?? '' ).match( /^(\d{2})\.(\d{2})\.(\d{4})(?:\s+(\d{2}):(\d{2}))?/ )
			if( ru ) return `${ ru[1] }.${ ru[2] }.${ ru[3] }${ ru[4] ? ` ${ ru[4] }:${ ru[5] }` : '' }`
			return String( date ?? '' )
		}

		static iso( date: string ) {
			const ru = String( date ?? '' ).match( /^(\d{2})\.(\d{2})\.(\d{4})(?:\s+(\d{2}):(\d{2}))?/ )
			if( ru ) return `${ ru[3] }-${ ru[2] }-${ ru[1] }${ ru[4] ? ` ${ ru[4] }:${ ru[5] }` : '' }`
			return String( date ?? '' )
		}

	}

}
